/**
 * Runtime configuration for the SPA.
 *
 * The backend API base URL is resolved at runtime so the SAME static build works in every
 * environment: a container entrypoint writes `window.__PATC_CONFIG__` (see the web Dockerfile / infra),
 * falling back to the Vite env var in dev, then to localhost. See docs/architecture.md.
 */
interface RuntimeConfig {
  apiBaseUrl?: string;
}

declare global {
  interface Window {
    __PATC_CONFIG__?: RuntimeConfig;
  }
}

const runtime = typeof window !== "undefined" ? window.__PATC_CONFIG__ : undefined;

export const API_BASE_URL: string =
  runtime?.apiBaseUrl ||
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ||
  "http://localhost:8080";
